module.exports = ".container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column; }\n\n.message {\n  text-align: center;\n  margin-bottom: 20px; }\n\n.button {\n  margin-top: 20px;\n  width: 100px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/card-payment/card-payment.component.scss
// module id = ./src/app/dashboard/card-payment/card-payment.component.scss
// module chunks = main